// extracted by mini-css-extract-plugin
module.exports = {"form":"AddToken_form__kBg7f"};